import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import Select from "react-select";
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Flatpickr from "react-flatpickr";
import { dateFormat, formatDateToISO } from 'pages/Common';
import uploadImage from "../../assets/images/no_image.jpg"
import Dropzone from "react-dropzone"
import Compressor from "compressorjs"

const CreateUpdateKhaKhaRackModel = ({ modal, toggle, rackShelfDataListApi, isEdit, editData, rackShelf }) => {
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [rackShelfId, setRackShelfId] = useState(editData?.RackshelfId || 0)
    const [previewUrl, setPreviewUrl] = useState(editData?.Image ?? '')
    const [base64Image, setBase64Image] = useState('')
    const [isUpdateImage, setIsUpdateImage] = useState(false)

    useEffect(() => {
        if (isEdit) {
            setRackShelfId(editData?.RackshelfId || 0)
            setPreviewUrl(editData?.Image ?? '')
        } else {
            setRackShelfId(0)
            setPreviewUrl('')
        }
    }, [editData])


    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Name: editData ? editData.Name : '',
            Description: editData ? editData.Description : '',
        },
        validationSchema: Yup.object({
            Name: Yup.string().required("The name is required"),
            Description: Yup.string().required("The Description is required"),
        }),
        onSubmit: values => {
            if (parseInt(rackShelfId) == 0 || rackShelfId == '0') {
                toast.error("Please select rack shelf", {
                    style: {
                        fontSize: "15px",
                    },
                })
                return true
            }
            if ((!isUpdateImage && base64Image == '' && !isEdit)) {
                toast.error("Please select image", {
                    style: {
                        fontSize: "15px",
                    },
                })
                return true
            }
            if ((isEdit && editData?.Image == '')) {
                toast.error("Please select image", {
                    style: {
                        fontSize: "15px",
                    },
                })
                return true
            }
            setformSumitLoading(true)
            if (values) {
                postApi("Rackshelf/data/create-update", {
                    Id: isEdit ? editData.Id : 0,
                    RackshelfId: parseInt(rackShelfId),
                    Name: values.Name,
                    Image: isUpdateImage ? base64Image?.split(",")[1] : (editData.Image || ''),
                    Description: values.Description,
                    IsMaterial: false,
                }).then(({ data, status }) => {
                    setformSumitLoading(false)
                    if (status == 200) {
                        toast.success(isEdit ? "Sucessfully Updated" : "Sucessfully created", {
                            style: {
                                fontSize: "15px",
                            },
                        })
                        toggle()
                        if (rackShelfDataListApi != '') {
                            rackShelfDataListApi()
                        }
                        setRackShelfId(0)
                        setPreviewUrl('')
                        setBase64Image('')
                        setIsUpdateImage(false)
                        validation.handleReset()
                    } else {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    }
                })
            }
        },
    })

    const handleCancel = () => {
        setIsUpdateImage(false)
        setPreviewUrl('')
        setBase64Image('')
        validation.handleReset()
        setRackShelfId(0)
        toggle()
    }

    const toBase64 = file =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })

    const handleDrop = acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        new Compressor(selectedFile, {
            quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
            success: async compressedResult => {
                setIsUpdateImage(true)
                setPreviewUrl(URL.createObjectURL(compressedResult))
                setBase64Image(await toBase64(compressedResult))
            },
        })
    }

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)

    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="xl"
            style={{ width: !isMobile ? "500px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Kha_Kha Rack" : "Create Kha_Kha Rack"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={5} className="table-header">
                                <Label htmlFor="validationCustom03" className="required">
                                    Rack Shelf
                                </Label>
                                <Input
                                    type="select"
                                    id="validationCustom01"
                                    className="form-control"
                                    bsSize='sm'
                                    name="taskType"
                                    // onChange={validation.handleChange}
                                    onChange={e => {
                                        setRackShelfId(e.target.value)
                                    }}
                                    value={rackShelfId}
                                >
                                    <option value={0}>Select</option>
                                    {rackShelf.map((item, index) => {
                                        return (
                                            <option key={index} value={item.Key}>
                                                {item.Value}
                                            </option>
                                        )
                                    })}
                                </Input>
                            </Col>
                            <Col md={7}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03" className="required">
                                        Name
                                    </Label>
                                    <Input
                                        name="Name"
                                        placeholder="Name"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Name}
                                        invalid={
                                            validation.touched.Name && validation.errors.Name
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Name && validation.errors.Name ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Name}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03" className="required">
                                        Description
                                    </Label>
                                    <Input
                                        name="Description"
                                        placeholder="Enetr Description "
                                        type="textarea"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Description}
                                        invalid={
                                            validation.touched.Description && validation.errors.Description
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Description && validation.errors.Description ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Description}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <FormGroup>
                                <Dropzone
                                    onDrop={handleDrop}
                                    onClick={handleDrop}
                                    accept="image/*"
                                    multiple={false}
                                    id="profilePic"
                                    name="profilePic"
                                >
                                    {({ getRootProps, getInputProps }) => (
                                        <>
                                            <div className="d-flex flex-column align-items-center text-center p-2 py-3">
                                                {previewUrl ? (
                                                    <>
                                                        <div className="position-relative overflow-hidden product-image">
                                                            <input {...getInputProps()} />
                                                            <img
                                                                style={{
                                                                    cursor: "pointer",
                                                                    border: "1px solid #ced4da",
                                                                    borderRadius: "3px",
                                                                }}
                                                                width="175px"
                                                                height="200px"
                                                                src={previewUrl}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <input {...getInputProps()} />

                                                        <div
                                                            style={{
                                                                width: "175px",
                                                                height: "200px",
                                                                border: "1px solid #ced4da",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "3px",
                                                            }}
                                                        >
                                                            <img
                                                                className="img-fluid"
                                                                style={{}}
                                                                src={uploadImage}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </Dropzone>
                            </FormGroup>
                        </Row>

                        <div className="text-end">
                            <Button
                                task-title="secondary"
                                className="btn btn-primary me-2 btn-sm "
                                type="reset"
                                color="secondary"
                                onClick={() => handleCancel()}
                            >
                                Cancle
                            </Button>
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    color="primary"
                                    task-title="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    )
}

export default CreateUpdateKhaKhaRackModel